import { RequestHistory, RequestFile, RequestCharge } from '@app/core';
import { RequestActions } from '../actions';
import { RequestFeedback } from '@app/core/models';

export interface State {
  requestHistory: RequestHistory[];
  requestFiles: RequestFile[];
  requestCharge: RequestCharge[];
  requestFeedbacks: RequestFeedback[] | null;
  feedbacksTotal: number | 0;
}

export const initialState: State = {
  requestHistory: null,
  requestFiles: null,
  requestCharge: null,
  requestFeedbacks: null,
  feedbacksTotal: 0
};

export function reducer(state = initialState, action: RequestActions.RequestActions): State {
  switch (action.type) {
    case (RequestActions.RequestActionTypes.LoadRequestHistory): {
      return {
        ...state,
        requestHistory: null
      }
    }
    case (RequestActions.RequestActionTypes.LoadRequestHistorySuccess): {
      return {
        ...state,
        requestHistory: action.payload
      }
    }

    case (RequestActions.RequestActionTypes.LoadRequestFiles): {
      return {
        ...state,
        requestFiles: null
      }
    }
    case (RequestActions.RequestActionTypes.LoadRequestFilesSuccess): {
      return {
        ...state,
        requestFiles: action.payload
      }
    }
    case (RequestActions.RequestActionTypes.LoadRequestCharge): {
      return {
        ...state,
        requestCharge: null
      }
    }
    case (RequestActions.RequestActionTypes.LoadRequestChargeSuccess): {
      return {
        ...state,
        requestCharge: action.payload
      }
    }

    case (RequestActions.RequestActionTypes.LoadRequestFeedbacks): {
      return {
        ...state,
        requestFeedbacks: null
      }
    }
    case (RequestActions.RequestActionTypes.LoadRequestFeedbacksSuccess): {
      return {
        ...state,
        requestFeedbacks: action.payload.items,
        feedbacksTotal: action.payload.paging.totalItems
      }
    }

    default:
      return state;
  }
}

export const getRequestHistory = (state: State) => state.requestHistory;
export const getRequestFiles = (state: State) => state.requestFiles;
export const getRequestCharge = (state: State) => state.requestCharge;
export const getRequestFeedbacks = (state: State) => state.requestFeedbacks;
export const selectFeedbacksTotal = (state: State) => state.feedbacksTotal;



// WEBPACK FOOTER //
// ./src/app/core/store/reducers/request.reducers.ts